import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

// --- Interfaces ---
import type { IVersion, IVersions } from '@interfaces/version';

export interface IGetVersionsParams {
	search?: string;
	inactive?: boolean;
	solutionId?: 'Portal' | 'AFV';
	page?: number;
	pageLimit?: number;
	tenantId?: number;
}

@Injectable({
	providedIn: 'root',
})
export class VersionsService {
	constructor(private readonly _http: HttpClient) {}

	getVersions(queryParams?: IGetVersionsParams) {
		return this._http.get<IVersions>('versions', {
			params: (<unknown>queryParams) as HttpParams,
		});
	}

	getVersion(id: IVersion['id']) {
		return this._http.get<IVersion>(`versions/${id}`);
	}

	newVersion(version: IVersion) {
		return this._http.post<IVersion>('versions', version);
	}

	editVersion(id: IVersion['id'], version: IVersion) {
		return this._http.put<IVersion>(`versions/${id}`, version);
	}

	deleteVersion(id: IVersion['id']) {
		return this._http.delete<IVersion>(`versions/${id}`);
	}

	activate(id: IVersion['id']) {
		return this._http.post<IVersion>(`versions/${id}/activate`, {});
	}

	getLatestVersion(queryParams?: IGetVersionsParams) {
		return this._http.get<IVersion>('versions/latest', {
			params: (<unknown>queryParams) as HttpParams,
		});
	}
}
